module.exports = __webpack_public_path__ + "static/media/Logo.0d4e3623.svg";